<template>
  <div class="FAQ">
    <div class="FAQ-content">
      <div class="FAQ-left">
        <div class="title-56">{{ $t('keypalTwo.FAQ.title') }}</div>
        <div class="desc-18">{{ $t('keypalTwo.FAQ.desc_1') }}</div>
        <div class="question-list">
          <div
            class="question-item"
            :class="{ 
              active: questionId === item.id, 
              'border-bottom': questionId !== item.id && questionId !== item.id + 1,
              'border-top': questionId === item.id - 1
            }"
            v-for="(item, index) in questionList"
            :key="index"
            @click="onQuestion(item, index)"
          >
            <div class="question-item-title">
              <span>{{ item.question }}</span>
              <img 
                v-if="questionId !== item.id || isMobileSize" 
                :src="enterImg" 
                alt="" 
              />
            </div>
            <div class="answer-list" v-if="questionId === item.id">
              <div class="markdown-body" v-html="compiledMarkdown"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="FAQ-right hidden-scrollbar">
        <div class="markdown-body" v-html="compiledMarkdown"></div>
      </div>
    </div>
    <div class="discover-content">
      <picture>
        <source srcset="../../assets/images/keypal-two/discover-m.png" media="(max-width: 767px)" />
        <img src="../../assets/images/keypal-two/discover.png" alt="" />
      </picture>
      <div class="discover-wrap">
        <div ref="fittyBox" class="discover-title">
          {{ $t('keypalTwo.discover.title') }}
        </div>
        <div class="discover-btn" @click="goShoppingCart">{{ $t('keypalTwo.discover.desc_1') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import markdownit from 'markdown-it'
import fitty from 'fitty';
import AnswerItem from "./AnswerItem.vue";
import { mapGetters } from 'vuex';

// import enmd from "../../i18n/lang/en/en.md";
// const mdContent = require('../../i18n/lang/en/en.md')

export default {
  components: { AnswerItem },
  data() {
    return {
      questionId: 0,
      mobileIndex: undefined,
      answerShowMap: {
        show_0: false,
        show_1: false,
        show_2: false,
        show_3: false,
        show_4: false,
      },
      rawMd: '',
      rawMdMap: {
        'en': {},
        'es': {},
        'fr': {},
        'ja': {},
        'ko': {},
        'zh': {},
        'zh-tw': {},
      },
      // compiledMarkdown: '',
    };
  },
  created() {
    // this.getMarkdownContent('en', this.questionId + 1);
    for (const key in this.rawMdMap) {
      this.questionList.forEach(item => {
        this.getMarkdownContent(key, item.id + 1);
      });
    }
  },
  computed: {
    ...mapGetters(['isMobileSize']),
    compiledMarkdown() {
      const md = markdownit(
        {
          breaks: true,
        }
      );
      // return md.render(this.$t('keypalTwo.FAQ.markdown_1'));
      const rawMd = this.rawMdMap[this.$i18n.locale][this.questionId + 1] || '';
      // return md.render(this.rawMd);
      // 给所有链接加 target="_blank"
      // const defaultRender = md.renderer.rules.link_open || function(tokens, idx, options, env, self) {
      //   return self.renderToken(tokens, idx, options);
      // };

      // md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
      //   const aIndex = tokens[idx].attrIndex('target');
      //   if (aIndex < 0) {
      //     tokens[idx].attrPush(['target', '_blank']); // 新标签页打开
      //   } else {
      //     tokens[idx].attrs[aIndex][1] = '_blank';
      //   }
      //   return defaultRender(tokens, idx, options, env, self);
      // };
      if (rawMd) {
        return md.render(rawMd);
      } else {
        return md.render(this.rawMd);
      }
    },
    questionList() {
      return [
        {
          question: this.$t('keypalTwo.FAQ.question_1'),
          id: 0,
        },
        {
          question: this.$t('keypalTwo.FAQ.question_2'),
          id: 1,
        },
        {
          question: this.$t('keypalTwo.FAQ.question_3'),
          id: 2,
        },
        {
          question: this.$t('keypalTwo.FAQ.question_4'),
          id: 3,
        },
        {
          question: this.$t('keypalTwo.FAQ.question_5'),
          id: 4,
        },
      ];
    },
    answer_0_List() {
      return [
        {
          label: this.$t('keypalTwo.FAQ.answer_1_1'),
          desc: this.$t('keypalTwo.FAQ.answer_1_2'),
        },
        {
          label: this.$t('keypalTwo.FAQ.answer_1_3'),
          desc: this.$t('keypalTwo.FAQ.answer_1_4'),
        },
        {
          label: this.$t('keypalTwo.FAQ.answer_1_5'),
          children: [
            {
              text: this.$t('keypalTwo.FAQ.answer_1_6_1'),
            },
            {
              text: this.$t('keypalTwo.FAQ.answer_1_6_2'),
            },
            {
              text: this.$t('keypalTwo.FAQ.answer_1_6_3'),
            },
          ],
        },
        {
          label: this.$t('keypalTwo.FAQ.answer_1_7'),
          desc: this.$t('keypalTwo.FAQ.answer_1_8'),
        },
      ];
    },
    answer_1_List() {
      return [
        {
          desc: this.$t('keypalTwo.FAQ.answer_2_1'),
        },
      ];
    },
    answer_2_List() {
      return [
        {
          desc: this.$t('keypalTwo.FAQ.answer_3_1'),
        },
      ];
    },
    answer_3_List() {
      return [
        {
          desc: this.$t('keypalTwo.FAQ.answer_4_1'),
        },
      ];
    },
    answer_4_List() {
      return [
        {
          desc: this.$t('keypalTwo.FAQ.answer_5_1'),
        },
      ];
    },
    answerList() {
      return this[`answer_${this.questionId}_List`] || [];
    },
    enterImg() {
      return require(`../../assets/images/keypal-two/arrow-2${this.darkModeImg}.png`);
    },
  },
  mounted() {
    if (this.isMobileSize) {
      return
    }
    // 在组件挂载后初始化 fitty
    // this.fittyInstance = fitty(this.$refs.fittyBox, {
    //   minSize: 18, // 最小字体
    //   maxSize: 80, // 最大字体
    //   multiLine: true, // 支持多行
    // });
  },
  watch: {
    text() {
      // 当文本变化时重新适配
      if (this.fittyInstance) {
        this.fittyInstance[0]?.fit();
      }
    },
    "$i18n.locale": {
      handler(newLocale) {
        // 当语言变化时重新获取 Markdown 内容
        // this.getMarkdownContent(newLocale, this.questionId + 1);
      },
      immediate: true, // 初始时也执行一次
    },
    isMobileSize(newVal) {
      if (!newVal) {
        this.questionId = 0;
        this.answerShowMap = {
          show_0: false,
          show_1: false,
          show_2: false,
          show_3: false,
          show_4: false,
        };
        
      }
    },
  },
  beforeDestroy() {
    // 销毁 fitty 实例，避免内存泄漏
    if (this.fittyInstance) {
      this.fittyInstance[0]?.destroy();
    }
  },

  methods: {
    goShoppingCart() {
      let url = `https://keypal.store/`;
      if (this.isZh) {
        url = `https://j.youzan.com/o5Rh1B`;
      }
      window.open(url, '_blank');
    },
    getMarkdownContent(language, index) {
      let publicPath = process.env.VUE_APP_ENV === 'production' ? '': '/keypal';
      fetch(`${publicPath}/markdown/keypal-2-FAQ/${language}/answer-${index}.md`) // 放在 public/ 下
        .then(res => res.text())
        // .then(text => { this.rawMd = text; });
        .then(text => { 
            this.rawMd = text; // 初始化的时候
            this.rawMdMap[language][index] = text; 
          });
    },
    onQuestion(item, index) {
      if (this.isMobileSize) {
        if (this.questionId === item.id) {
          this.questionId = null;
        } else {
          this.questionId = item.id;
        }
        return
      }
      this.questionId = item.id
      this.answerShowMap[`show_` + item.id] = !this.answerShowMap[`show_` + item.id]
      if (this.rawMdMap[this.$i18n.locale][index + 1]) {
        return
      }
      this.getMarkdownContent(this.$i18n.locale, index + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.FAQ {
  background: var(--bg-1);
  .FAQ-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 88px 0;
    display: flex;
    // align-items: center;
    gap: 0 72px;

    .answer-list {
      display: flex;
      flex-direction: column;
      gap: 32px 0;
    }

    .FAQ-left {
      width: 568px;
      .title-56 {
        text-align: left;
      }
      .desc-18 {
        margin-top: 32px;
        text-align: left;
      }
      .question-list {
        margin-top: 32px;
        .question-item {
          .question-item-title {
            height: 80px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            span {
              font-size: 20px;
              font-weight: 500;
              text-align: left;
              color: var(--color-1);
            }
  
            img {
              width: 14px;
              height: 8px;
              transform: rotate(-90deg);
            }
          }
          &.active {
            border-bottom: 1px solid transparent;
            .question-item-title {
              padding: 0 16px;
              background: linear-gradient(90deg, #2980fe, var(--bg-9) 100%);
              border-radius: 16px;
              span {
                color: #ffffff;
              }

              // img {
              //   transform: rotate(0);
              //   transition: transform 0.3s ease;
              // }
            }
          }

          &.border-bottom {
            border-bottom: 1px solid var(--border-3);
          }

          .answer-list {
            display: none;
          }
        }
      }
    }
    .FAQ-right {
      flex: 1;
      max-height: 680px;
      overflow: auto;
    }
  }

  .discover-content {
    max-width: 1200px;
    margin: 80px auto 0;
    // padding-top: 80px;
    position: relative;

    picture {
      img {
        width: 100%;
        height: auto;
      }
    }

    .discover-img {
      width: 100%;
      height: auto;
    }

    .discover-wrap {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;

      .discover-title {
        width: 280px;
        // font-size: 28px;
        font-size: clamp(12px, 2.5vw, 28px);
        font-weight: 600;
        // color: var(--color-1);
        color: #000;
        text-align: center;
        word-break: break-word;  /* 内容过长自动断行 */
        white-space: normal; /* 允许自动换行 */
      }

      .discover-btn {
        margin-top: 16px;
        font-size: 18px;
        color: var(--color-3);
        height: 44px;
        line-height: 44px;
        background: #2980fe;
        border-radius: 41px;
        padding: 0 42px;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .FAQ {
    font-size: 30px;
    .FAQ-content {
      padding: 88px 20px 0;

      .FAQ-left {
        // width: auto;
        flex: 1;
        .title-56 {
          font-size: 0.8em;
        }

        .desc-18 {
          font-size: 0.5em;
        }

        .question-list {
          .question-item {
            .question-item-title {
              span {
                font-size: 0.45em;
              }
            }
          }
        }
      }
    }

    .discover-content {
      margin: 0 20px;

      .discover-wrap {
        .discover-title {
          width: calc(280 / 1300 * 100vw);
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .FAQ {
    .FAQ-content {
      padding: 0 28px;

      .FAQ-left {
        .desc-18 {
          margin-top: 15px;
        }

        .question-list {
          margin-top: 24px;

          .question-item {
            .question-item-title {
              height: 53px;
              line-height: 53px;
              height: auto;
              line-height: normal;
              padding: 15px 0;

              span {
                font-size: 15px;
              }

              img {
                width: 10px;
                height: 6px;
              }
            }
            &.active {
              .question-item-title {
                padding: 15px 8px;
                border-radius: 8px;
                img {
                  transform: rotate(0);
                  transition: transform 0.3s ease;
                }
              }
            }

            &.border-top {
              border-top: 1px solid var(--border-3);
            }
            
            .answer-list {
              margin: 17px 0;
              display: flex;
              gap: 16px 0;
            }
          }
        }
      }
      
      .FAQ-right {
        display: none;
      }
    }

    .discover-content {
      margin: 85px 28px 0;
      // padding-top: 85px;

      .discover-wrap {
        width: 100%;
        // top: 10%;
        transform: translate(-50%, 0);
        top: 0;
        height: 63%;
        justify-content: center;

        .discover-title {
          padding: 0 20px;
          max-width: 320px;
          font-size: 24px;
          width: calc(280 / 450 * 100vw);
        }

        .discover-btn {
          margin-top: 12px;
          min-width: 97px;
          height: 38px;
          line-height: 38px;
          padding: 0 20px;
          font-size: 14px;
          text-align: center;
        }
      }
    }
  }
}
</style>
